import { MultipleUnitsFieldData, MultipleUnitsFieldMetadata } from 'models/forms/fields/MultipleUnitsFieldMetadata';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { Amount } from 'routes/essential-workspace/components/form/fields/shared/amount/amount';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function MultipleUnitField({ id, isReadOnly, nbDecimals, units }: MultipleUnitsFieldMetadata) {
  const [value, setValue] = useFormFieldData<MultipleUnitsFieldData>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  return (
    <ErrorWrapper error={fieldError}>
      <Amount
        hasError={fieldError?.severity === 'Error'}
        highlightColor={fieldError?.severity === 'Warning' ? 'info' : undefined}
        currency={units[value.valueType]}
        id={id}
        isReadOnly={isReadOnly}
        value={value?.value}
        nbDecimals={nbDecimals}
        setValue={v => setValue({ ...value, value: v ?? null, changeTarget: 'value' })}
      />
    </ErrorWrapper>
  );
}
